import classnames from 'classnames';
import * as React from 'react';
import { hocFieldWrapper } from "../FieldWrapper";
import style from './Input.scss';

export type Props = {
  invalid?: boolean
} & React.InputHTMLAttributes<HTMLInputElement>;

export const Input = React.forwardRef<HTMLInputElement, Props>((props, ref) => {
  const { className, invalid, ...restProps } = props;

  return <input
    {...restProps}
    ref={ref}
    className={classnames(style.input, invalid && style.inputInvalid, className)}
  />;
});

export default hocFieldWrapper(Input);
